import React, { useState } from 'react';
import { COLORS, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';

const DEFAULT_FILTER = 'all';

const Root = styled(Row)`
  margin: 16px 0;
`;

const Filter = styled(Text)`
  border-radius: 4px;
  background: ${({ isSelected }) => (isSelected ? COLORS.COLA : COLORS.GRAY_XXXLIGHT)};
  color: ${({ isSelected }) => (isSelected ? COLORS.WHITE : COLORS.COLA)};
  cursor: pointer;
  padding: 4px 12px;
  text-transform: capitalize;
  margin-right: 8px;
  min-width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function Filters({ filters, handleFilterChange, singleSelect }) {
  const defaultState = [DEFAULT_FILTER];
  const [selectedFilter, setSelectedFilter] = useState(defaultState);

  const setFilter = filter => {
    if (filter === DEFAULT_FILTER) {
      handleFilter(defaultState);
    } else if (singleSelect) {
      handleFilter([filter]);
    } else {
      if (selectedFilter.includes(filter)) {
        const filteredFilter = selectedFilter?.filter(item => item !== filter);
        if (!filteredFilter.length) {
          handleFilter([...defaultState]);
          return;
        }
        handleFilter([...filteredFilter]);
      }
      if (selectedFilter.includes(DEFAULT_FILTER)) {
        const noDefaultFilter = selectedFilter?.filter(item => item !== DEFAULT_FILTER);
        handleFilter([...noDefaultFilter, filter]);
      } else {
        handleFilter([...selectedFilter, filter]);
      }
    }
  };

  const handleFilter = val => {
    setSelectedFilter(val);
    handleFilterChange(val);
  };

  function getFilters() {
    return [DEFAULT_FILTER, ...filters]?.map(filter => (
      <Filter
        key={filter}
        isSelected={selectedFilter.includes(filter)}
        variant="body3"
        onClick={() => setFilter(filter)}
      >
        {filter}
      </Filter>
    ));
  }
  return <Root>{getFilters()}</Root>;
}
